import React from 'react';
import ImagingScheduleList from './imagingScheduleList';
import ScheduleDetails from './scheduleDetails';
import PlatesToImage from './platesToImage';
import InspectionsToScore from './inspectionsToScore';
import {
  ImagingSchedulesDTO,
  ImagingSchedulesDeletedDataDTO,
  PlateInspectionsToScoreDTO,
  PlatesToImageDTO,
} from 'business/models/Models';
import { ScheduleRowInfo } from './types';
import { RMModalProps } from 'components/modal/RMModal';

interface ImagingScheduleProps {
  imagingSchedulesDto: ImagingSchedulesDTO[];
  setImagingScheduleDto: React.Dispatch<React.SetStateAction<any[]>>;
  setDeletedData: React.Dispatch<React.SetStateAction<ImagingSchedulesDeletedDataDTO>>;
  scheduleErrors?: ScheduleRowInfo;
  platesToImage: PlatesToImageDTO[];
  plateInspectionsToScore: PlateInspectionsToScoreDTO[];
  setPlatesToImage: React.Dispatch<React.SetStateAction<PlatesToImageDTO[]>>;
  setPlateInspectionsToScore: React.Dispatch<
    React.SetStateAction<PlateInspectionsToScoreDTO[]>
  >;
  setModal?: React.Dispatch<React.SetStateAction<RMModalProps>>;
}

function ImagingScheduling(props: ImagingScheduleProps) {
  const {
    imagingSchedulesDto,
    setImagingScheduleDto,
    setDeletedData,
    scheduleErrors,
    platesToImage,
    plateInspectionsToScore,
    setPlatesToImage,
    setPlateInspectionsToScore,
    setModal,
  } = props;
  return (
    <div
      id="imagingscheduling-wrapper"
      className="flex h-[91vh] min-h-0 flex-col overflow-hidden [&_.fmlx-table_.table-main_tbody_tr]:!text-[13px] [&_.fmlx-table_.table-main_th]:!text-[13px] [&_.fmlx-table_.table-main_td]:!text-[13px]"
    >
      <div
        id="imagingscheduling-schedule-container"
        className="flex min-h-0 w-full flex-1 basis-0 flex-row"
      >
        <div
          id="imagingscheduling-schedule-list"
          className="min-h-0 w-[30%] overflow-hidden border"
        >
          <ImagingScheduleList
            imagingSchedulesDto={imagingSchedulesDto}
            setImagingScheduleDto={setImagingScheduleDto}
            setDeletedData={setDeletedData}
            scheduleErrors={scheduleErrors}
            setModal={setModal}
          />
        </div>
        <div
          id="imagingscheduling-schedule-details"
          className="min-h-0 min-w-0 w-[70%] overflow-hidden border"
        >
          <ScheduleDetails
            imagingSchedules={imagingSchedulesDto}
            setImagingScheduleDto={setImagingScheduleDto}
            setDeletedData={setDeletedData}
            scheduleErrors={scheduleErrors}
            setModal={setModal}
          />
        </div>
      </div>
      <div
        id="imagingscheduling-plates-container"
        className="flex min-h-0 w-full flex-1 basis-0 flex-row"
      >
        <div
          id="imagingscheduling-plates-toimage"
          className="min-h-0 min-w-0 w-1/2 overflow-hidden border"
        >
          <PlatesToImage
            platesToImage={platesToImage}
            setPlatesToImage={setPlatesToImage}
            setDeletedData={setDeletedData}
          />
        </div>
        <div
          id="imagingscheduling-plates-toscore"
          className="min-h-0 min-w-0 w-1/2 overflow-hidden border"
        >
          <InspectionsToScore
            plateInspectionsToScore={plateInspectionsToScore}
            setPlateInspectionsToScore={setPlateInspectionsToScore}
            setDeletedData={setDeletedData}
          />
        </div>
      </div>
    </div>
  );
}

export default ImagingScheduling;
